import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"translate(1 1)scale(1.2222)\"><g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M17.25 16.5H3.75a2.25 2.25 0 0 1-2.25-2.25V.75a.75.75 0 0 0-1.5 0v13.5A3.754 3.754 0 0 0 3.75 18h13.5a.75.75 0 1 0 0-1.5\"></path><path d=\"M4.5 15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-1.5 0v5.25a.75.75 0 0 0 .75.75M7.5 7.5v6.75a.75.75 0 1 0 1.5 0V7.5a.75.75 0 0 0-1.5 0M11.25 9.75v4.5a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 1 0-1.5 0M15 6.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 1 0-1.5 0M4.5 6.75a.75.75 0 0 0 .53-.22l2.69-2.69a.77.77 0 0 1 1.06 0l1.63 1.63a2.25 2.25 0 0 0 3.18 0l4.19-4.19A.75.75 0 0 0 16.72.22l-4.19 4.188a.75.75 0 0 1-1.06 0L9.84 2.78a2.25 2.25 0 0 0-3.18 0L3.97 5.47a.75.75 0 0 0 .53 1.28\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h18v18H0z\"></path></clipPath></defs></g>", 1)
  ]))]))
}
export default { render: render }